export { NewTicketComponent } from "./new-ticket.component"
